import { z } from 'zod';

const optionalString = (schema: z.ZodString) =>
  z.preprocess(
    v => (typeof v === 'string' && v.trim() === '' ? undefined : v),
    schema.optional()
  ) as unknown as z.ZodType<string | undefined>;

const isDigitalOceanSpacesUrl = (value: string) => {
  try {
    const url = new URL(value);
    const isHttp = url.protocol === 'https:' || url.protocol === 'http:';
    const host = url.hostname.toLowerCase();
    const isSpacesDomain = host === 'digitaloceanspaces.com' || host.endsWith('.digitaloceanspaces.com');
    const hasSubdomain = host.split('.').length > 2;

    return isHttp && isSpacesDomain && hasSubdomain;
  } catch {
    return false;
  }
};

export { optionalString, isDigitalOceanSpacesUrl };
